import React from "react";
import { Link } from "react-router-dom";
import {
  G1,
  G2,
  G3,
  G4,
  G5,
  G6,
  G7,
  G8,
  G9,
  G10,
  G11,
  G12,
  G13,
  G14,
  G15,
  G16,
  G17,
  G18,
  G19,
  G20,
  G21,
  G22,
  G23,
  G24,
  G25,
  G26,
  G27,
  G28,
  G29,
  G30,
  G31,
  G32,
  G33,
  G34,
  G35,
  G36,
  G37,
  G38,
  G39,
  G40,
  G41,
  G43,
  G44,
  G45,
  G46,
  G47,
  G48,
  G49,
  G50,
  G51,
  G52,
  G53,
  G54,
  G55,
  G56,
  G57,
  G58,
  G59,
  G60,
  G61,
  G62,
  G63,
  G64,
  G65,
  G66,
  G67,
  G68,
  G69,
  G70,
  G71,
  G72,
  G73,
} from "../images";

const Gallery = () => {
  return (
    <>
      <div className="breadcrumb-area d-flex  p-relative align-items-center">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-xl-12 col-lg-12">
              <div className="breadcrumb-wrap text-center">
                <div className="breadcrumb-title">
                  <h2>Gallery</h2>
                </div>
              </div>
            </div>
            <div className="breadcrumb-wrap2">
              <ol className="breadcrumb">
                <li className="breadcrumb-item">
                  <Link to="/">Home</Link>
                </li>
                <li className="breadcrumb-item active">Gallery</li>
              </ol>
            </div>
          </div>
        </div>
      </div>
      <div className="gallery-bg">
        <div className="container">
          <div className="row">
            <div className="col-sm-3">
              <div className="main-gallery">
                <img src={G1} alt="" />
              </div>
            </div>
            <div className="col-sm-3">
              <div className="main-gallery">
                <img src={G2} alt="" />
              </div>
            </div>
            <div className="col-sm-3">
              <div className="main-gallery">
                <img src={G3} alt="" />
              </div>
            </div>
            <div className="col-sm-3">
              <div className="main-gallery">
                <img src={G4} alt="" />
              </div>
            </div>
            <div className="col-sm-3">
              <div className="main-gallery">
                <img loading="lazy" src={G5} alt="" />
              </div>
            </div>
            <div className="col-sm-3">
              <div className="main-gallery">
                <img loading="lazy" src={G6} alt="" />
              </div>
            </div>
            <div className="col-sm-3">
              <div className="main-gallery">
                <img loading="lazy" src={G7} alt="" />
              </div>
            </div>
            <div className="col-sm-3">
              <div className="main-gallery">
                <img loading="lazy" src={G8} alt="" />
              </div>
            </div>
            <div className="col-sm-3">
              <div className="main-gallery">
                <img loading="lazy" src={G9} alt="" />
              </div>
            </div>
            <div className="col-sm-3">
              <div className="main-gallery">
                <img loading="lazy" src={G10} alt="" />
              </div>
            </div>
            <div className="col-sm-3">
              <div className="main-gallery">
                <img loading="lazy" src={G11} alt="" />
              </div>
            </div>
            <div className="col-sm-3">
              <div className="main-gallery">
                <img loading="lazy" src={G12} alt="" />
              </div>
            </div>
            <div className="col-sm-3">
              <div className="main-gallery">
                <img loading="lazy" src={G13} alt="" />
              </div>
            </div>
            <div className="col-sm-3">
              <div className="main-gallery">
                <img loading="lazy" src={G14} alt="" />
              </div>
            </div>
            <div className="col-sm-3">
              <div className="main-gallery">
                <img loading="lazy" src={G15} alt="" />
              </div>
            </div>
            <div className="col-sm-3">
              <div className="main-gallery">
                <img loading="lazy" src={G16} alt="" />
              </div>
            </div>
            <div className="col-sm-3">
              <div className="main-gallery">
                <img loading="lazy" src={G17} alt="" />
              </div>
            </div>
            <div className="col-sm-3">
              <div className="main-gallery">
                <img loading="lazy" src={G18} alt="" />
              </div>
            </div>
            <div className="col-sm-3">
              <div className="main-gallery">
                <img loading="lazy" src={G19} alt="" />
              </div>
            </div>
            <div className="col-sm-3">
              <div className="main-gallery">
                <img loading="lazy" src={G20} alt="" />
              </div>
            </div>
            <div className="col-sm-3">
              <div className="main-gallery">
                <img loading="lazy" src={G21} alt="" />
              </div>
            </div>
            <div className="col-sm-3">
              <div className="main-gallery">
                <img loading="lazy" src={G22} alt="" />
              </div>
            </div>
            <div className="col-sm-3">
              <div className="main-gallery">
                <img loading="lazy" src={G23} alt="" />
              </div>
            </div>
            <div className="col-sm-3">
              <div className="main-gallery">
                <img loading="lazy" src={G24} alt="" />
              </div>
            </div>
            <div className="col-sm-3">
              <div className="main-gallery">
                <img loading="lazy" src={G25} alt="" />
              </div>
            </div>
            <div className="col-sm-3">
              <div className="main-gallery">
                <img loading="lazy" src={G26} alt="" />
              </div>
            </div>
            <div className="col-sm-3">
              <div className="main-gallery">
                <img loading="lazy" src={G27} alt="" />
              </div>
            </div>
            <div className="col-sm-3">
              <div className="main-gallery">
                <img loading="lazy" src={G28} alt="" />
              </div>
            </div>
            <div className="col-sm-3">
              <div className="main-gallery">
                <img loading="lazy" src={G29} alt="" />
              </div>
            </div>
            <div className="col-sm-3">
              <div className="main-gallery">
                <img loading="lazy" src={G30} alt="" />
              </div>
            </div>
            <div className="col-sm-3">
              <div className="main-gallery">
                <img loading="lazy" src={G31} alt="" />
              </div>
            </div>
            <div className="col-sm-3">
              <div className="main-gallery">
                <img loading="lazy" src={G32} alt="" />
              </div>
            </div>
            <div className="col-sm-3">
              <div className="main-gallery">
                <img loading="lazy" src={G33} alt="" />
              </div>
            </div>
            <div className="col-sm-3">
              <div className="main-gallery">
                <img loading="lazy" src={G34} alt="" />
              </div>
            </div>
            <div className="col-sm-3">
              <div className="main-gallery">
                <img loading="lazy" src={G35} alt="" />
              </div>
            </div>
            <div className="col-sm-3">
              <div className="main-gallery">
                <img loading="lazy" src={G36} alt="" />
              </div>
            </div>
            <div className="col-sm-3">
              <div className="main-gallery">
                <img loading="lazy" src={G37} alt="" />
              </div>
            </div>
            <div className="col-sm-3">
              <div className="main-gallery">
                <img loading="lazy" src={G38} alt="" />
              </div>
            </div>
            <div className="col-sm-3">
              <div className="main-gallery">
                <img loading="lazy" src={G39} alt="" />
              </div>
            </div>
            <div className="col-sm-3">
              <div className="main-gallery">
                <img loading="lazy" src={G40} alt="" />
              </div>
            </div>
            <div className="col-sm-3">
              <div className="main-gallery">
                <img loading="lazy" src={G41} alt="" />
              </div>
            </div>
            <div className="col-sm-3">
              <div className="main-gallery">
                <img loading="lazy" src={G43} alt="" />
              </div>
            </div>
            <div className="col-sm-3">
              <div className="main-gallery">
                <img loading="lazy" src={G44} alt="" />
              </div>
            </div>
            <div className="col-sm-3">
              <div className="main-gallery">
                <img loading="lazy" src={G45} alt="" />
              </div>
            </div>
            <div className="col-sm-3">
              <div className="main-gallery">
                <img loading="lazy" src={G46} alt="" />
              </div>
            </div>
            <div className="col-sm-3">
              <div className="main-gallery">
                <img loading="lazy" src={G47} alt="" />
              </div>
            </div>
            <div className="col-sm-3">
              <div className="main-gallery">
                <img loading="lazy" src={G48} alt="" />
              </div>
            </div>
            <div className="col-sm-3">
              <div className="main-gallery">
                <img loading="lazy" src={G49} alt="" />
              </div>
            </div>
            <div className="col-sm-3">
              <div className="main-gallery">
                <img loading="lazy" src={G50} alt="" />
              </div>
            </div>
            <div className="col-sm-3">
              <div className="main-gallery">
                <img loading="lazy" src={G51} alt="" />
              </div>
            </div>
            <div className="col-sm-3">
              <div className="main-gallery">
                <img loading="lazy" src={G52} alt="" />
              </div>
            </div>
            <div className="col-sm-3">
              <div className="main-gallery">
                <img loading="lazy" src={G53} alt="" />
              </div>
            </div>
            <div className="col-sm-3">
              <div className="main-gallery">
                <img loading="lazy" src={G54} alt="" />
              </div>
            </div>
            <div className="col-sm-3">
              <div className="main-gallery">
                <img loading="lazy" src={G55} alt="" />
              </div>
            </div>
            <div className="col-sm-3">
              <div className="main-gallery">
                <img loading="lazy" src={G56} alt="" />
              </div>
            </div>
            <div className="col-sm-3">
              <div className="main-gallery">
                <img loading="lazy" src={G57} alt="" />
              </div>
            </div>
            <div className="col-sm-3">
              <div className="main-gallery">
                <img loading="lazy" src={G58} alt="" />
              </div>
            </div>
            <div className="col-sm-3">
              <div className="main-gallery">
                <img loading="lazy" src={G59} alt="" />
              </div>
            </div>
            <div className="col-sm-3">
              <div className="main-gallery">
                <img loading="lazy" src={G60} alt="" />
              </div>
            </div>
            <div className="col-sm-3">
              <div className="main-gallery">
                <img loading="lazy" src={G61} alt="" />
              </div>
            </div>
            <div className="col-sm-3">
              <div className="main-gallery">
                <img loading="lazy" src={G62} alt="" />
              </div>
            </div>
            <div className="col-sm-3">
              <div className="main-gallery">
                <img loading="lazy" src={G63} alt="" />
              </div>
            </div>
            <div className="col-sm-3">
              <div className="main-gallery">
                <img loading="lazy" src={G64} alt="" />
              </div>
            </div>
            <div className="col-sm-3">
              <div className="main-gallery">
                <img loading="lazy" src={G65} alt="" />
              </div>
            </div>
            <div className="col-sm-3">
              <div className="main-gallery">
                <img loading="lazy" src={G66} alt="" />
              </div>
            </div>
            <div className="col-sm-3">
              <div className="main-gallery">
                <img loading="lazy" src={G67} alt="" />
              </div>
            </div>
            <div className="col-sm-3">
              <div className="main-gallery">
                <img loading="lazy" src={G68} alt="" />
              </div>
            </div>
            <div className="col-sm-3">
              <div className="main-gallery">
                <img loading="lazy" src={G69} alt="" />
              </div>
            </div>
            <div className="col-sm-3">
              <div className="main-gallery">
                <img loading="lazy" src={G70} alt="" />
              </div>
            </div>
            <div className="col-sm-3">
              <div className="main-gallery">
                <img loading="lazy" src={G71} alt="" />
              </div>
            </div>
            <div className="col-sm-3">
              <div className="main-gallery">
                <img loading="lazy" src={G72} alt="" />
              </div>
            </div>
            <div className="col-sm-3">
              <div className="main-gallery">
                <img loading="lazy" src={G73} alt="" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Gallery;
